/**
 * Status of the AllocationInstructionAlertRequest(35=DU).
 * tag: 2768
 * @readonly
 * @enum {number} (int)
 */
export enum AllocRequestStatus {
  /** Accepted */
  Accepted = 0,
  /** Rejected */
  Rejected = 1,
}
